<template>
  <div class="sidebar fill-height">
    <v-card>
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab v-for="item in items" :key="`tab-${item.name}`">
          <v-icon small class="icon" @mouseover="help('fragmap', 'excl')">
            {{ item.icon }}
          </v-icon>
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="tab-items">
        <v-tab-item key="FragMap">
          <v-card flat class="d-flex flex-column">
            <fragmap />
            <fragmaphelp />
          </v-card>
        </v-tab-item>
        <v-tab-item key="Ligands">
          <v-card flat class="d-flex flex-column">
            <!-- <ligand />
            <ligandhelp /> -->
            <mcligand />
            <mcligandhelp />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <el-tabs value="fragmap" type="border-card" class="tabcard">
      <el-tab-pane name="fragmap" label="FragMap">
        <fragmap></fragmap>
        <fragmaphelp></fragmaphelp>
      </el-tab-pane>
      <el-tab-pane name="ligand" label="Ligand">
        <ligand></ligand>
        <ligandhelp></ligandhelp>
      </el-tab-pane>
      <el-tab-pane name="mc-ligand" label="MC-Ligand">
        <mcligand></mcligand>
        <mcligandhelp></mcligandhelp>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>
import fragmap from "./FragMap.vue";
import fragmaphelp from "./FragMapHelp.vue";
import ligand from "./Ligand.vue";
import ligandhelp from "./LigandHelp.vue";
import mcligand from "./MCLigand.vue";
import mcligandhelp from "./MCLigandHelp.vue";

export default {
  name: "Sidebar",
  components: {
    fragmap,
    fragmaphelp,
    ligand,
    ligandhelp,
    mcligand,
    mcligandhelp,
  },
  data() {
    return {
      tab: null,
      items: [
        { name: "FragMaps", icon: "mdi-dots-grid" },
        { name: "Ligands", icon: "mdi-table-row-plus-before" },
      ],
      text: "FragMap",
    };
  },
  methods: {
    help(topic, maptype, event) {
      this.$store.dispatch("help", {
        topic: topic,
        maptype: maptype,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

.tabcard {
  width: 100%;
  height: calc(100% - 10px);
  display: flex;
  flex-direction: column;
}

.sidebar {
  margin: 5px 5px 5px 5px;
  flex: 1;
}
</style>

<style>
.v-label {
  font-size: 13px !important;
}

.v-slider__thumb {
  height: 12px;
  width: 12px;
}

.v-slider--horizontal .v-slider__track-container {
  height: 4px;
}

.tab-items {
  margin-top: 10px;
  margin-left: 10px;
}

.inline-block > div {
  display: inline-block;
}
.v-input--checkbox {
  margin-top: 0;
}
.v-messages {
  display: none;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-slider--horizontal {
  min-height: 20px;
}
.row {
  margin: 3px 10px;
}
.col {
  padding: 0px 0px;
}
h2 {
  margin: 20px 0;
}
.v-tab {
  font-weight: 700 !important;
}
.v-tab--active {
  color: #1a6aa9 !important;
}
.icon {
  margin-right: 10px;
}
.help-on .name {
  margin-bottom: 3px;
}
.help-on .row {
  background-color: #f9f6f6;
  margin: 0;
  padding: 12px 10px;
  font-size: 13px;
}

.shadow {
  /* box-shadow: #bbb 0px 4px 10px; */
  margin: 8px 0 0 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 370px;
  min-height: 20em;
  bottom: 0px;
  height: 350px;
  margin-right: 10px;
}
.border-top {
  border-top: solid 1px #eee;
}
.navigation {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #8492a6;
  font-size: 0.9em;
}
.navigation i {
  font-size: 1.1em;
}
.navigation i:hover {
  color: #20a0ff;
  cursor: pointer;
}
.navigation i.close:hover {
  color: #ff4949;
}
.navigation .open:hover {
  color: #20a0ff;
  cursor: pointer;
}
.help .row {
  max-height: 250px;
  overflow-y: auto;
}
.help {
  font-size: 0.9em;
  cursor: text;
  user-select: text;
  width: 100%;
}
.help-on {
  display: block;
  width: 100%;
}
.help-off {
  display: none;
}
.control-panel {
  max-height: 436px;
  overflow-y: auto;
}
</style>
